import { render, staticRenderFns } from "./ProgresoRegistro.vue?vue&type=template&id=4ee264cf&"
import script from "./ProgresoRegistro.vue?vue&type=script&lang=js&"
export * from "./ProgresoRegistro.vue?vue&type=script&lang=js&"
import style0 from "./ProgresoRegistro.vue?vue&type=style&index=0&id=4ee264cf&prod&lang=css&"
import style1 from "./ProgresoRegistro.vue?vue&type=style&index=1&id=4ee264cf&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports